import { Button } from "reactstrap";
import { trackEvent } from 'utils/Analytics';

const AnalyticButton = (props) => {
  const { children, onClick, tracking, ...rest } = props;

  const buttonOnClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (tracking) {
      trackEvent(tracking.category, tracking.action, tracking.label)
    }
  }

  return (
    <Button
      {...rest}
      onClick={buttonOnClick}
    >
      {children}
    </Button>
  )
}

export default AnalyticButton;